import React from "react"
import classNames from "utils/classNames"

type SectionSeperatorProps = {
  title: string | Element
  className?: string
}
const SectionSeperator = ({ title, className }: SectionSeperatorProps) => {
  return (
    <>
      <h6 className={classNames("mt-6 vt-section-header", className)}>
        {title}
      </h6>
      <hr className="mt-0" />
    </>
  )
}

export default SectionSeperator
